import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DateFormats } from "../constants/dateFormats";

export const convertToLocal = (date: string | Date | undefined | null, format: DateFormats = DateFormats.DATE_HOUR): string => {
    dayjs.extend(utc);
    return dayjs.utc(date).local().format(format);
};

export const formatHour = (date: any): string => {
    return dayjs(date).format(DateFormats.HOUR_MINUTE);
};
export const formatDate = (date: any, format: DateFormats = DateFormats.DATE_HOUR): any => {
    return date ? dayjs(date).format(format) : null;
};

export const getLocalDate = (format?: DateFormats) => {
    return dayjs().format(format);
};

export const getCurrentDate = () => {
    return dayjs(new Date()).startOf("day").toDate();
};

